import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      event: this.props.event,
    };
  },
  onError() {
    var updated = this.state.event;
    updated.main_image_url_medium = "/images/ja2/img_noimage.gif";
    this.setState({
      event: updated,
    });
  },
  render() {
    var event = this.state.event;
    return (
      <div className="touch-box" style={{ width: "200px" }} data-event-id={event.id}>
        <article className="circle-box" style={{ height: "100%" }}>
          <a className="timeline_circle-link" href={`/event/${event.id}`}>
            <div className="timeline_circle-image">
              <img
                src={event.main_image_url_medium}
                alt={event.title}
                onError={this.onError}
              />
            </div>
            <div className="timeline_circle-description">
              <h3
                className="line-2 font-size-14"
                style={{ height: "38px", lineHeight: "1.5" }}
              >
                {event.title}
              </h3>
              <h4 className="line-1 font-size-10">
                {event.event_date_formatted}
              </h4>
              <p className="font-size-10 color-main-strong">
                {event.circle && event.circle.name} /{" "}
                {event.countries_pref ? event.countries_pref.name : ""}
              </p>
            </div>
          </a>
        </article>
      </div>
    );
  },
});
